import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { KERALA_THERAPIES } from '../data/content';

export default function KeralaTherapies() {
  const [expanded, setExpanded] = useState(null);
  return (
    <div style={{background:'#1E1108',paddingTop:'68px',minHeight:'100vh'}}>
      <Helmet>
        <title>Kerala Therapies in Bhopal | Best massage therapy near me</title>
        <meta name="description" content="Authentic Kerala Ayurveda therapies in Bhopal — Shirodhara, Abhyanga, Kati Basti, Pizhichil, Navarakizhi, Udwarthanam and more by Dr. Monika Jain."/>
      </Helmet>

      <div style={{padding:'70px 48px 50px',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
        <div style={{maxWidth:'1280px',margin:'0 auto'}}>
          <span style={{fontSize:'10px',letterSpacing:'3px',color:'#C8941A',textTransform:'uppercase',fontWeight:500,display:'block',marginBottom:'14px'}}>Kerala Tradition</span>
          <h1 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'62px',color:'#F0E6D8',lineHeight:1.05,marginBottom:'18px'}}>Kerala Therapies</h1>
          <p style={{fontSize:'16px',color:'rgba(240,230,216,0.45)',maxWidth:'560px',lineHeight:1.8}}>Authentic Kerala Ayurvedic therapies performed using classical protocols and genuine Kottakkal & Vaidyaratnam oils by trained therapists under Dr. Monika Jain's expert guidance.</p>
        </div>
      </div>

      <div style={{padding:'60px 48px 100px'}}>
        <div style={{maxWidth:'1280px',margin:'0 auto',display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:'2px'}}>
          {KERALA_THERAPIES.map((therapy)=>(
            <div key={therapy.id} style={{background:'#261408',overflow:'hidden',cursor:'pointer',transition:'background 0.25s'}}
              onMouseEnter={e=>e.currentTarget.style.background='#2E1A08'}
              onMouseLeave={e=>e.currentTarget.style.background='#261408'}
            >
              <div style={{height:'240px',overflow:'hidden',position:'relative'}}>
                <img src={therapy.img} alt={therapy.name} style={{width:'100%',height:'100%',objectFit:'cover',filter:'none',transition:'transform 0.6s ease'}}
                  onMouseEnter={e=>e.target.style.transform='scale(1.04)'}
                  onMouseLeave={e=>e.target.style.transform='scale(1)'}
                />

              </div>
              <div style={{padding:'26px 28px'}}>
                <h2 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'26px',color:'#F0E6D8',marginBottom:'10px'}}>{therapy.name}</h2>
                <p style={{fontSize:'14px',color:'rgba(240,230,216,0.55)',lineHeight:1.8,marginBottom:'10px'}}>{therapy.desc}</p>
                {therapy.process && (
                  <div style={{marginBottom:'14px'}}>
                    <div style={{fontSize:'11px',color:'#C8941A',letterSpacing:'1.5px',textTransform:'uppercase',fontWeight:600,marginBottom:'6px'}}>How it's done</div>
                    <p style={{fontSize:'13px',color:'rgba(240,230,216,0.45)',lineHeight:1.75}}>{therapy.process}</p>
                  </div>
                )}
                <div style={{display:'flex',gap:'6px',flexWrap:'wrap',marginBottom:'16px'}}>
                  {therapy.benefits.map(b=>(
                    <span key={b} style={{fontSize:'11px',color:'rgba(200,148,26,0.75)',background:'rgba(200,148,26,0.08)',border:'1px solid rgba(200,148,26,0.18)',padding:'4px 10px',borderRadius:'2px'}}>{b}</span>
                  ))}
                </div>
                <Link to="/book-appointment" style={{fontSize:'12px',color:'rgba(240,230,216,0.4)',letterSpacing:'0.5px',borderBottom:'1px solid rgba(240,230,216,0.12)',paddingBottom:'2px',display:'inline-flex',alignItems:'center',gap:'6px',transition:'color 0.2s',textDecoration:'none'}}
                  onMouseEnter={e=>e.currentTarget.style.color='#C8941A'}
                  onMouseLeave={e=>e.currentTarget.style.color='rgba(240,230,216,0.4)'}
                >Book This Therapy →</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
